// extracted by mini-css-extract-plugin
module.exports = {"container":"WhatsappButton_container__IUMYn","icon":"WhatsappButton_icon__3MYmV"};